import * as React from "react"

const SvgTrendingDownMini = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M1.31754 3.83333C1.11754 4.02222 1.01199 4.25 1.00088 4.51667C0.989766 4.78333 1.08421 5.02222 1.28421 5.23333L4.55088 8.45C4.93977 8.83889 5.40088 9.03333 5.93421 9.03333C6.46754 9.03333 6.92866 8.83889 7.31754 8.45L8.46754 7.31667L11.1675 10.0333H10.3842C10.1142 10.0333 9.88282 10.1294 9.69004 10.3215C9.49727 10.5136 9.40088 10.7442 9.40088 11.0132C9.40088 11.2822 9.49727 11.5139 9.69004 11.7083C9.88282 11.9028 10.1142 12 10.3842 12H13.5509C13.8209 12 14.0523 11.9036 14.245 11.7108C14.4378 11.5181 14.5342 11.2867 14.5342 11.0167V7.86667C14.5342 7.59667 14.4382 7.36528 14.246 7.1725C14.0539 6.97972 13.8234 6.88333 13.5544 6.88333C13.2854 6.88333 13.0537 6.97811 12.8592 7.16767C12.6648 7.35733 12.5675 7.58478 12.5675 7.85V8.65L9.85088 5.93333C9.46199 5.54444 9.00088 5.35 8.46754 5.35C7.93421 5.35 7.4731 5.54444 7.08421 5.93333L5.93421 7.08333L2.70088 3.83333C2.50088 3.63333 2.27032 3.53333 2.00921 3.53333C1.7481 3.53333 1.51754 3.63333 1.31754 3.83333Z"/>
  </svg>
)
export default SvgTrendingDownMini
